/**
 * Hero Slider Protection
 * Prevents conflicts with other scripts
 * 
 * OPTIONAL: Only use if hero slider still has issues after wishlist.js update
 * Save as: assets/hero-slider-protection.js
 * 
 * Add to theme.liquid BEFORE wishlist.js:
 * <script src="{{ 'hero-slider-protection.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  // Store original addEventListener to prevent overwrites
  const originalAddEventListener = Element.prototype.addEventListener;
  
  // Track hero slider elements
  const heroSliderSelectors = [
    '[data-slideshow]',
    '.slideshow',
    '.hero-slider',
    '[data-section-type*="slideshow"]',
    '[data-section-type*="hero"]'
  ];

  function isHeroSliderElement(element) {
    if (!element || !element.matches) return false;
    
    // Check if element or any parent is a hero slider
    let currentElement = element;
    while (currentElement) {
      for (const selector of heroSliderSelectors) {
        if (currentElement.matches && currentElement.matches(selector)) {
          return true;
        }
      }
      currentElement = currentElement.parentElement;
    }
    return false;
  }

  // Protected addEventListener for hero slider elements
  Element.prototype.addEventListener = function(type, listener, options) {
    // Apply original method
    originalAddEventListener.call(this, type, listener, options);

    // If this is a hero slider element, mark it as protected
    if (isHeroSliderElement(this)) {
      if (!this.dataset.heroSliderProtected) {
        this.dataset.heroSliderProtected = 'true';
      }
    }
  };

  // Protect existing hero sliders when DOM is ready
  function protectHeroSliders() {
    heroSliderSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!element.dataset.heroSliderProtected) {
          element.dataset.heroSliderProtected = 'true';
          
          // Prevent event bubbling interference
          ['click', 'touchstart', 'touchmove', 'touchend'].forEach(eventType => {
            element.addEventListener(eventType, function(e) {
              // Allow event to process normally, just mark it
              e.heroSliderEvent = true;
            }, { capture: true, passive: true });
          });
        }
      });
    });
  }

  // Initialize protection
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectHeroSliders);
  } else {
    protectHeroSliders();
  }

  // Re-protect after theme section loads
  document.addEventListener('shopify:section:load', function(event) {
    setTimeout(protectHeroSliders, 100);
  });

  console.log('Hero Slider Protection: Active');

})();